"use client";
import { useRollbarConfiguration } from './useRollbarConfiguration.js';

function useRollbarPerson(person) {
  useRollbarConfiguration({
    payload: {
      person: person
    }
  });
}

export { useRollbarPerson };
//# sourceMappingURL=useRollbarPerson.js.map
